'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _class, _temp2;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _ModalContainer = require('./ModalContainer');
var _ModalContainer2 = _interopRequireDefault(_ModalContainer);
var _styles = require('./styles');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var BlockNavigationModal = (_temp2 = _class = function (_PureComponent) {
  _inherits(BlockNavigationModal, _PureComponent);
  function BlockNavigationModal() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, BlockNavigationModal);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BlockNavigationModal.__proto__ || Object.getPrototypeOf(BlockNavigationModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: true
    }, _this.closeModal = function () {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      _this.setState({
        isOpen: false
      }, function () {
        _this.props.callBack(action);
      });
    }, _this.renderHeader = function () {
      return _react2.default.createElement(_styles.Title, null, 'Aten\xE7\xE3o!');
    }, _this.renderFooter = function () {
      return _react2.default.createElement(_styles.ContainerFooter, null, _react2.default.createElement(_styles.Cancel, {
        onClick: function onClick() {
          return _this.closeModal();
        }
      }, 'Cancelar'), _react2.default.createElement(_styles.Confirm, {
        onClick: function onClick() {
          return _this.closeModal(false);
        }
      }, 'Sair'));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(BlockNavigationModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_ModalContainer2.default, {
        onClose: this.closeModal,
        isOpen: this.state.isOpen,
        header: this.renderHeader(),
        footer: this.renderFooter()
      }, _react2.default.createElement(_styles.Container, null, _react2.default.createElement(_styles.Content, null, this.props.message)));
    }
  }]);
  return BlockNavigationModal;
}(_react.PureComponent), _class.defaultProps = {
  message: _react2.default.createElement(_react.Fragment, null, 'Ao sair, todos os dados do formul\xE1rio ser\xE3o perdidos.', _react2.default.createElement('br', null), 'Deseja prosseguir?'),
  callBack: function callBack() {}
}, _temp2);
exports.default = BlockNavigationModal;